import { render, staticRenderFns } from "./NavComponent.vue?vue&type=template&id=4e4ca476&scoped=true"
import script from "./NavComponent.vue?vue&type=script&lang=js"
export * from "./NavComponent.vue?vue&type=script&lang=js"
import style0 from "./NavComponent.vue?vue&type=style&index=0&id=4e4ca476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4ca476",
  null
  
)

export default component.exports